import React from 'react';

import ViewOptions, {
  ViewOptionsHeading,
  ViewOptionsOption,
} from 'components/ViewOptions';

const OptionsItem = ({
  label,
  id,
  handleChange,
  name,
  options,
  onBeforeInput = null,
}) => {
  let optionsId = '';
  if (options !== undefined) {
    optionsId = options[name];
  }

  const inputProps = {
    name,
    value: id,
    onChange: handleChange,
    onBeforeInput,
    checked: optionsId === id,
  };

  return (
    <ViewOptionsOption
      id={id}
      inputProps={inputProps}
    >
      {label}
    </ViewOptionsOption>
  );
};

const NotesViewOptions = ({
  options,
  handleChangeOptions,
  afterDismissViewOptions,
}) => {
  return (
    <>
      <ViewOptions menuClass='note-index__view-options'
        afterDismiss={() => afterDismissViewOptions()}
      >
        <div className="view-options__section">
          <ViewOptionsHeading>View As</ViewOptionsHeading>
          <OptionsItem
            label="Grid"
            name="view"
            id="grid"
            options={options}
            handleChange={() => handleChangeOptions('view', 'grid')}
          />
          <OptionsItem
            label="List"
            name="view"
            id="list"
            options={options}
            handleChange={() => handleChangeOptions('view', 'list')}
          />
        </div>
      </ViewOptions>
    </>
  );
};

export default NotesViewOptions;
